import { Component, inject, OnInit } from '@angular/core';
import { SignupAccessService } from '../../modules/auth0/services/signup-access.service';
import { Auth0Store } from '../../modules/auth0/store';
import { TopNavComponent } from '../../shared/containers/top-nav/top-nav.component';

@Component({
  selector: 'gnx-about-franklin',
  templateUrl: './about-franklin.component.html',
  styleUrls: ['./about-franklin.component.scss'],
  imports: [TopNavComponent],
})
export class AboutFranklinComponent implements OnInit {
  private signupAccessService = inject(SignupAccessService);

  protected auth0Store = inject(Auth0Store);
  public isSignupAllowed: boolean;

  constructor() {
    this.isSignupAllowed = this.signupAccessService.isSignupAllowed();
  }

  ngOnInit(): void {}
}
